import '../css'

addEventListener('shown.bs.modal', ({ target }) => {
  if (target.matches('#address_verification_modal')) {
    document.querySelector('#user_input').focus()
  }
})

addEventListener('hidden.bs.modal', ({ target }) => {
  if (target.matches('#address_verification_modal')) {
    const { default: country } = document.querySelector('#country_select').dataset
    document.querySelector('button[data-country]').dataset.country = country
    document.querySelector('#address_verification_modal input[name=country]').value = country
    document.querySelector('#user_input').value = ''
    document.querySelector('#address_verification_results').innerHTML = ''
  }
})

addEventListener('click', e => {
  if (e.target.matches('#country_select a')) {
    e.preventDefault()

    const { country } = e.target.dataset
    document.querySelector('button[data-country]').dataset.country = country
    document.querySelector('#address_verification_modal input[name=country]').value = country
  }

  if (e.target.matches('.picklist_item')) {
    const { moniker, display, postcode, score } = e.target.dataset
    const form = document.querySelector('form#address_refiner')
    form.querySelector('input[name=user_input]').value = ''
    form.querySelector('input[name=moniker]').value = moniker
    form.querySelector('input[name=display]').value = display
    form.querySelector('input[name=postcode]').value = postcode
    form.querySelector('input[name=score]').value = score
    form.requestSubmit()
  }
})

addEventListener('keypress', e => {
  if (e.target.matches('input.address_search_field') && e.key == 'Enter') {
    e.preventDefault()
    document.querySelector('#address_verification_submit_button').click()
  }
})

addEventListener('turbo:submit-start', ({ target }) => {
  if (target.matches('#address_search_form')) {
    document.querySelector('#address_verification_results').innerHTML = 'Searching ...'
  }
})

addEventListener('turbo:submit-end', async ({ target, detail: { success, fetchResponse: { contentType, response } }}) => {
  if (success && contentType.startsWith('application/json') && (target.matches('#address_search_form') || target.matches('#address_refiner'))) {
    const json = await response.json()

    for (const k of ['country_id', 'line1', 'line2', 'line3', 'municipality', 'postal_code']) {
      document.getElementById(`generic_request_${k}`).value = json[k]
    }
    document.getElementById('generic_request_is_verified').value = 'true'

    const event = new CustomEvent('addressVerified', { bubbles: true, detail: { country_division_id: json['country_division_id'] } })
    document.getElementById('address_verification_modal').dispatchEvent(event)
  }
})

addEventListener('turbo:frame-load', () => {
  document.querySelector('#address_refiner #user_input')?.focus()
})
